
<template>
    <v-app id="overviewFeratel">
      <v-main>
      <v-container fluid>  
      <v-card>
        <v-card-title>Overview Feratel</v-card-title>
        <v-row dense no-gutters>

        <v-col cols="1" class="mx-2">
            <v-menu v-model="huovVanDatVanmenu" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="huovVanDatVan" label="Arrival date from" clearable
                        v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="hulpDate" :first-day-of-week="1"
                    @input="huovVanDatVan = $moment(hulpDate).format('DD-MM-YYYY'); huovVanDatVanmenu = false"></v-date-picker>
            </v-menu>
        </v-col>

        <v-col cols="1" class="mx-2">
            <v-menu v-model="huovVanDatTmmenu" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="huovVanDatTm" label="Arrival date until" clearable
                        v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="hulpDate" :first-day-of-week="1"
                    @input="huovVanDatTm = $moment(hulpDate).format('DD-MM-YYYY'); huovVanDatTmmenu = false"></v-date-picker>
            </v-menu>
        </v-col>

        <v-col cols="2" class="mx-2">
            <v-select v-model="huovServiceTeam" label="Feratel Service team" :items="serviceTeamChoices" multiple></v-select>
        </v-col>

        <v-col cols="2" class="mx-2">
            <v-select v-model="huovTravelPartyComplete" label="Travel Party Completion" :items="travelPartyCompleteChoices" multiple></v-select>
        </v-col>

        <v-col cols="2" class="mx-2">
            <v-select v-model="huovGuestCard" label="Guestcard" :items="guestCardChoices2" item-text="oms" item-value="value" multiple></v-select>
        </v-col>

        <v-col cols="1">
                    <v-btn class="primary ma-0" small @click="getHuov" :loading="loading">Search</v-btn>
                </v-col>
                <v-col cols="2" class="pt-4 ml-8">
              <!-- <v-btn small plain v-on:click="expandAll()">expand all</v-btn>                          
              <v-btn small plain v-on:click="collapseAll()">collapse all</v-btn> -->
            </v-col>   
            </v-row>
        
        <v-data-table 
            :items="items" 
            :headers="headers" 
            :search="search" 
            sort-by="huov_van_dat"
            :disable-pagination=true 
            no-data-text="No bookings to display" 
            :hide-default-footer="true" 
            loading-text="Loading data...please wait" 
            :loading="loading" 
            :expanded.sync="expanded"
            item-key="huov_code"
            show-expand
            >
                                                
                        <template v-slot:expanded-item="{ item }">   
                            <td colspan="2" class="indent encapsulated_td">
                                <span v-if="item.nott.length!==0"> 
                                <p v-for="note in item.nott" :key="note.nott_dt" align="center">{{ note.nott_dt }}</p>
                                </span>
                                <span v-else>
                                <p>No data available</p>
                                </span>
                            </td>
                            <td class="encapsulated_td">
                                <p v-for="note in item.nott" :key="note.nott_dt">{{ note.nott_gebr_code }}</p>
                            </td>  
                            <td colspan="12" class="encapsulated_td">
                                <p v-for="note in item.nott" :key="note.nott_dt"><span v-html="note.nott_tekst"></span></p>
                            </td>        
                        </template>
                        
                        <template v-slot:item.type = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">
                                <v-chip v-if="item.type==='RC'" color="#8A2BE2" class="hust-code">{{ item.type }} </v-chip>
                                <v-chip v-if="item.type==='HB'" color="#8BB4D8" class="hust-code">{{ item.type }} </v-chip>
                                <v-chip v-if="item.type==='IB'" color="#416C99" class="hust-code">{{ item.type }} </v-chip>
                            </td>
                        </template>

                        <template v-slot:item.huov_code = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" @click="$router.open(getLink(item))" class="font-row"><a>
                                {{ item.huov_code }} </a></td>
                        </template>
                        
                        <template v-slot:item.hust_code = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row"><v-chip small :color=item.hust_kleur class="hust-code"><span class="chiptext">{{ item.hust_code }}</span></v-chip></td>
                        </template>
                        
                        <template v-slot:item.huis_code = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" @click="$router.open('/huis/onHuis/' + item.huis_encrid)" class="font-row"><a> {{ item.huis_code }} </a></td>
                        </template>

                        <template v-slot:item.huov_dt = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ $moment(item.huov_dt).format("DD-MMM-YYYY HH:mm") }}</td>
                        </template>

                        <template v-slot:item.huov_pers = "{item}">
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ item.huov_pers }}</td>
                        </template>

                        <template v-slot:item.huov_van_dat = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ $moment(item.huov_van_dat).format("DD-MMM-YYYY ddd") }}</td>
                        </template>
                        
                        <template v-slot:item.huov_tm_dat = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ $moment(item.huov_tm_dat).format("DD-MMM-YYYY ddd") }}</td>
                        </template>

                        <template v-slot:item.klnt_naam = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" @click="$router.open(getCustLink(item))" class="font-row">
                                <div class="flex">
                                    <a>{{ item.klnt_naam }}</a> 
                                    <div v-if="!item.hasEmail" class="last-item"><v-icon small color="red" style="margin-left: auto !important;">mdi-email-off-outline</v-icon></div>
                                </div>    
                            </td>   
                        </template>

                        <template v-slot:item.inpt_naam = "{item}">
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ item.inpt_naam }}</td>
                        </template>
                            
                        <template v-slot:item.huov_travelparty_complete = "{item}">
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ item.huov_travelparty_complete }}</td>
                        </template>
                        <template v-slot:item.huov_feratel_mblattnr = "{item}">
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ item.huov_feratel_mblattnr }}
                                <v-icon small v-if="item.feratel_used_fake_travelparty" color="orange">
                                        mdi-alert-outline
                                    </v-icon>

                            </td>
                        </template>
                        <template v-slot:item.huov_feratel_guid = "{item}">
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ item.huov_feratel_guid }}</td>
                        </template>
                        <template v-slot:item.huov_feratel_service = "{item}">
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ item.huov_feratel_service }}</td>
                        </template>
                        <template v-slot:item.feratel_guestcard = "{item}">
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ item.feratel_guestcard }} 
                                <v-icon  v-if="item.feratel_guestcard_processed !== ''" color="green">
                                        mdi-check-bold
                                    </v-icon>
                            </td>
                        </template>

                        <template v-slot:item.huis_feratel_loginname = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">{{ item.huis_feratel_loginname }}</td>
                        </template>

                        <template v-slot:item.huov_days_before_arrival = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }" class="font-row">
                                    <v-chip v-if="item.huov_days_before_arrival > 0" v-bind:class="{ 'success' : item.huov_travelparty_complete === 'OK' , 'warning' : item.huov_travelparty_complete === 'NotComplete' }">
                                        {{ item.huov_days_before_arrival }}</v-chip>
                                    
                                        <v-icon  v-if="item.huov_feratel_mblattnr !== ''" color="green">
                                        mdi-check-bold
                                    </v-icon>
                                        
                                </td>
                        </template>

                        <template v-slot:item.huov_remark = "{item}">   
                            <td v-bind:class="{ 'grey lighten-2' : $moment(item.huov_van_dat) <= $moment() }">
                                <v-badge v-if="item.nott.length!==0" :content="item.nott.length">
                                    <v-icon @click="nott(item.huov_encrid);">mdi-clipboard-text-outline</v-icon>
                                </v-badge>
                                <v-icon v-if="item.nott.length===0" @click="nott(item.huov_encrid);">mdi-clipboard-text-outline</v-icon>
                            </td>  
                        </template>

                    </v-data-table>
      </v-card>  
      </v-container>
      </v-main>
      <nott ref="nott"></nott>
      <navBar title="Ares - Various" :home="true" type="various" />
      <!-- <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/> -->
    </v-app>
  </template>
  
  
  <script>
      import navBar from "@/components/ui/navbars/navbar.vue";
      import nott from "@/components/nott";
      export default {
          components: {
              navBar,
              nott
          },
          data() {
              return {
                overviewFeratel: [],
                search: '',
                loading: false,
                expanded: [],
                headers: [
                    { text: 'Type', value: 'type' },    
                    { text: 'Id', value: 'huov_code' },
                    { text: 'Status', value: 'hust_code' },
                    { text: 'Accommodation', value: 'huis_code' },
                    { text: 'Guest', value: 'klnt_naam' },
                    { text: 'Feratel Login', value: 'huis_feratel_loginname' },
                    { text: 'Booking', value: 'huov_dt' },
                    { text: 'Persons', value: 'huov_pers' },
                    { text: 'Arrival', value: 'huov_van_dat' },
                    { text: 'Departure', value: 'huov_tm_dat' },
                    { text: 'Sales partner', value: 'inpt_naam' },
                    { text: 'Travel Party', value: 'huov_travelparty_complete'},
                    { text: 'Feratel Mblattnr', value: 'huov_feratel_mblattnr'},
                    { text: 'Feratel Guid', value: 'huov_feratel_guid'},
                    { text: 'Feratel Service team', value: 'huov_feratel_service'},
                    { text: 'Guestcard', value: 'feratel_guestcard'},
                    { text: 'Days before arrival', value: 'huov_days_before_arrival'},
                    { text: 'Remark', value: 'huov_remark'},
                    { text: '', value: 'data-table-expand', sortable: false }
                ],
                items:[],
                huovVanDatVan: '',
                huovVanDatTm: '',
                huovVanDatVanmenu: false,
                huovVanDatTmmenu: false,
                serviceTeamChoices: [],
                travelPartyCompleteChoices: [],
                guestCardChoices: [],
                guestCardChoices2: [],
                huovServiceTeam: '',
                huovTravelPartyComplete: '',
                huovGuestCard: '',
                hulpDate: null,
              }  
          },
      mounted() {
                this.loading=true;
                this.$axios
                  .post("ares/json/ares/task/various/huov/overviewFeratel.p", {
                      header: {
                          token: this.$session.get("ARES"),
                          clientSessionId: this.$session.id(),
                          request: "overviewFeratel"
                      },
                      overviewFeratel: {
                        huov_van_dat_van: this.huovVanDatVan,
                        huov_van_dat_tm: this.huovVanDatTm,
                        serviceteam: this.huovServiceTeam,
                        guestcard: this.huovGuestCard,
                        travelparty: this.huovTravelPartyComplete,
                      }
                  })
                  .then(res => {
                      if (res.data.error) {
                          console.log(res.data.error);
                      } else {
                          this.items = res.data.searchHuov;
                          this.huovVanDatVan = res.data.huov_van_dat_van;
                          this.huovVanDatTm = res.data.huov_van_dat_tm;
                          this.serviceTeamChoices = res.data.serviceteamChoices;
                          this.travelPartyCompleteChoices = res.data.travelPartyCompleteChoices;
                          this.guestCardChoices = res.data.guestCardChoices;
                          this.guestCardChoices2 = res.data.guestCardChoices2;
                          this.loading = false;
                        
                      }
                  })
                  .finally(() => {
                      this.loading = false;
                  });
          },
          methods: {
            getHuov() {
                this.loading=true;
                this.$axios
                .post("ares/json/ares/task/various/huov/overviewFeratel.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "overviewFeratel"
                    },
                    overviewFeratel: {
                        huov_van_dat_van: this.huovVanDatVan,
                        huov_van_dat_tm: this.huovVanDatTm,
                        serviceteam: this.huovServiceTeam,
                        guestcard: this.huovGuestCard,
                        travelparty: this.huovTravelPartyComplete,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        this.items = res.data.searchHuov;
                        this.loading = false;
                    }
                })
            },
            nott(huov_encrid) {
                this.$refs.nott.open("huov", huov_encrid, "Feratel");
            },
            collapseAll() {
                this.expanded = [];
            }, 
                expandAll(){
                this.items.filter(e => e.nott.length !==0 ? this.expanded.push(e) : false);
            },
            getLink(linkitem){
                if(linkitem.type === 'RC'){
                    return "/huov/onHuov/" + linkitem.huov_encrid;
                }
                else return "/heho/onHeho/" + linkitem.huov_encrid + "/" + linkitem.huis_encrid;
            },
            getCustLink(linkitem){
                if(linkitem.type === 'RC'){
                    return "/klnt/onKlnt/" + linkitem.klnt_encrid;
                }
                else return "/heho/onHeho/" + linkitem.huov_encrid + "/" + linkitem.huis_encrid;

            } 
         }
      };
  
  </script> 

  <style scoped>
  .indent{
    text-align: center;
  }
  .encapsulated_td{
    border-top: 10px solid transparent;
  }
  .amount{
    text-align: end;
  }
  .hust-code{
    color:white;
  }
</style>
